import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-10" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Contact with us")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_jt_image_slider = _resolveComponent("jt-image-slider")!
  const _component_jt_contact_us_form = _resolveComponent("jt-contact-us-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_jt_timeline = _resolveComponent("jt-timeline")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_jt_need_guidance = _resolveComponent("jt-need-guidance")!
  const _component_jt_footer = _resolveComponent("jt-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_jt_image_slider),
    _hoisted_1,
    _createVNode(_component_v_row, { class: "mt-4 mx-md-12" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "8",
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, { class: "card-curved no-shadow px-15 py-6" }, {
              default: _withCtx(() => [
                _createVNode(_component_jt_contact_us_form)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_jt_timeline)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_jt_need_guidance),
    _createVNode(_component_jt_footer)
  ], 64))
}